/**
 * Created by nixuan on 2018/4/23.
 */
import store from 'store';
const data = {};

const getter = (field) => {
    const storageKey = `_${field}`;
    if (data[storageKey]) {
        return data[storageKey];
    }
    const storageVal = store.get(field);
    if (storageVal) {
        data[storageKey] = storageVal;
        return data[storageKey];
    }
    return null;
};

const setter = (field, val) => {
    const storageKey = `_${field}`;
    data[storageKey] = val;
    store.set(field, val);
};

const MpUserInfo = {
    get: () => {
        return getter('mpUserInfo')
    },
    getId: () => {
        const userInfo = getter('mpUserInfo');
        if (userInfo) {
            return userInfo.id;
        }
        return null;
    },
    set: (userInfo) => {
        setter('mpUserInfo', userInfo)
    },
};

const ChannelUserInfo = {
    get: () => {
        return getter('channelUserInfo')
    },
    getId: () => {
        const userInfo = getter('channelUserInfo');
        if (userInfo) {
            return userInfo.id;
        }
        return null;
    },
    set: (userInfo) => {
        setter('channelUserInfo', userInfo)
    },
    getBrief: () => {
        return getter('briefInfo');
    },
    setBrief: (briefInfo) => {
        setter('briefInfo', briefInfo);
    }
};

const AddressInfo = {
    get: () => {
        return getter('addressInfo');
    },
    set: (addressInfo) => {
        setter('addressInfo', addressInfo);
    }
};

export default {
    MpUserInfo,
    ChannelUserInfo,
    AddressInfo
};
